module.exports = __webpack_public_path__ + "img/logo.08228ff4.png";